import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { submenu } from './sub.menu';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import { MenuItemsModel } from '@core/menu/menu.model';
import { ProgramComponent } from './features/program/program.component';
import { ProgramsComponent } from './features/programs/programs.component';
import { B2bProgramResolverService } from './shared/service/b2b-program/b2b-program-resolver.service';
import { ProgramUploadsComponent } from './features/program/program-uploads/program-uploads.component';
import { ProgramInvoicesComponent } from './features/program/program-invoices/program-invoices.component';
import { ProgramInfoComponent } from './features/program/program-info/program-info.component';
import { ProgramAddComponent } from './features/program-add/program-add.component';

const dataPrivilege: Record<'moduleMenu', MenuItemsModel[]> = {
    moduleMenu: submenu,
};

const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Programs,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Programs,
        title: marker('modules.programs.head'),
        loadChildren: () => [
            { path: RouteEntity.Empty, component: ProgramsComponent },
            { path: RouteEntity.Add, component: ProgramAddComponent },
            {
                path: ':' + RoutingQueryParamsName.PrgId,
                component: ProgramComponent,
                resolve: {
                    b2bProgram: B2bProgramResolverService,
                },
                children: [
                    {
                        path: RouteEntity.Empty,
                        redirectTo: RouteEntity.Uploads,
                        pathMatch: 'full',
                    },
                    {
                        path: RouteEntity.Uploads,
                        component: ProgramUploadsComponent,
                    },
                    {
                        path: RouteEntity.Invoices,
                        component: ProgramInvoicesComponent,
                    },
                    {
                        path: RouteEntity.Info,
                        component: ProgramInfoComponent,
                    },
                ],
            },
        ],
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.AddRider,
        title: marker('modules.addRider.head'),
        loadComponent: () => import('./features/add-rider/add-rider.component').then((c) => c.AddRiderComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.RemoveRider,
        title: marker('modules.removeRider.head'),
        loadComponent: () => import('./features/remove-rider/remove-rider.component').then((c) => c.RemoveRiderComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    {
        path: RouteEntity.SearchRider,
        title: marker('modules.searchRider.head'),
        loadComponent: () => import('./features/search-rider/search-rider.component').then((c) => c.SearchRiderComponent),
        canLoad: [AuthGuard],
        data: dataPrivilege,
    },
    ...commonErrorRoutes,
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
